import {Grid, Typography} from "@mui/material";
import {useResponsive} from "../../../Modulo_Responsive/Hooks/useResponsive";
import Lista_Enfoque_Servicios from "./SubComponentes/Lista_Enfoque_Servicios";

const Enfoque_Servicios = () => {
    const {sCell} = useResponsive();
    return (
        <Grid
            container
            justifyContent="center"
            alignItems="center"
            size={{xs: 12, sm: 12, md: 12}}
            component="section"
        >
            <Grid
                container
                justifyContent="center"
                alignItems="center"
                size={{xs: 12, sm: 12, md: 10}}
                sx={{maxWidth:1400, px:3}}
            >
                <Grid
                    container
                    justifyContent="center"
                    alignItems="center"
                    size={{xs: 12, sm: 12, md: 12}}
                    sx={{borderBottom: '1px solid #DFDFDF', pb:12}}
                >
                    <Grid
                        container
                        justifyContent={'flex-start'}
                        alignItems={'center'}
                        size={{ xs: 12, sm: 12, md: 12 }}
                    >
                        <Typography
                            component="h2"
                            variant={'h2'}
                            sx={{
                                textAlign: 'center',
                            }}
                            itemProp="name"
                        >
                            Soluciones técnicas integradas
                        </Typography>
                    </Grid>
                    <Grid
                        container
                        justifyContent="center"
                        alignItems="center"
                        size={{xs: 12, sm: 12, md: 12}}
                        sx={{pt:8}}
                    >
                        <Lista_Enfoque_Servicios/>
                    </Grid>
                </Grid>
            </Grid>
        </Grid>
    );
};
export default Enfoque_Servicios;
